class ScheduleShareController {

    constructor() {
        this.view = new ScheduleShareView(
            this.onOpenShare.bind(this),
            this.onShare.bind(this),
            );
    }

    onOpenShare() {
        this.view.showShared();
    }

    onShare() {
        if(this.view.shareWithAdvistor.isChecked()) {
            plannerApplication.api.shareProfile();
        }
    }
}
